(function ($) {
  function setMainMargin() {
    $("#main").css("margin-top", $("header").height() + "px");
  }

  setMainMargin();

  logoSize();

  $(window).scroll(function () {
    logoSize();
  });

  $(window).on("resize", function () {
    setMainMargin();
  });

  function logoSize() {
    if ($(window).scrollTop() > 20) {
      $(".header").addClass("scrolled");
    } else {
      $(".header").removeClass("scrolled");
    }
  }
})(jQuery);
